import changePassword from "./changePassword"

export default {
  changePassword
}